import {FormItemProps, Input, InputProps} from 'antd'
import {
  Box,
  Button,
  Form,
  FormItem,
  Select,
  useForm,
  useWatch,
} from 'common/components'
import {FIELD_RULES, EMAIL_FIELD_RULES} from 'common/constants'
import {useGetAllUsersList} from '../../users'
import {useAssignMember} from '..'
import MemberSelectField from './MemberSelectField'
import { useEffect } from 'react'

interface UserBase {
  [propName:string]:any
}
interface Member {
  [propName:string]:any
}
interface TeamMemberFormProps {
  data: any // orgData
  user?: Member
  onClose: () => void
}

const Field = ({
  name,
  type,
  readOnly,
  ...props
}: FormItemProps & InputProps) => (
  <FormItem
    {...props}
    name={name}
    rules={type === 'email' ? EMAIL_FIELD_RULES : FIELD_RULES}
  >
    <Input
      type={type}
      autoFocus={name === 'firstName'}
      addonBefore={name === 'phone' ? '+64' : undefined}
      readOnly={readOnly}
    />
  </FormItem>
)

export default function TeamMemberForm({
  data: orgData, user, onClose
}: TeamMemberFormProps) {
  const {data: members} = useGetAllUsersList()
  const {mutate: assignTeamMember, isMutating: isCreating} =
    useAssignMember(orgData?.id, 'create', onClose)
  const {mutate: updateTeamMember, isMutating: isUpdating} =
    useAssignMember(orgData?.id, 'update', onClose)
  const isAssignMutating = isCreating || isUpdating

  const [form] = useForm()
  const isEdit = Boolean(user)

  const memberIdValue = useWatch('member', form)
  const memberValue = members?.find((x:any) => x.uuid === memberIdValue)
  // console.log(memberValue)

  useEffect(() => {
    if (isEdit) return
    
    if (!!memberValue?.email) {
      form.setFieldValue('email', memberValue.email)
    }
    if (!!memberValue?.phone) {
      form.setFieldValue('phone', memberValue.phone.replace('+64', ''))
    }
  }, [form, memberIdValue, isEdit])

  const handleFinish = ({member, ...values}: UserBase) => {
    const data:any = {
      ...values,
      userId: member,
      phone: `+64${values.phone.trim()}`,
    }
    if (!isEdit) assignTeamMember({...data})
    else updateTeamMember({...data})
  }

  const initialValues = !!user ? {
    ...user
  } : { }

  const orgType = orgData?.type
  const roleEditOptions = orgData?.roles?.map((x:any) => ({
    value: x.id, label: x.displayName
  }))
  return (
    !orgType ? null :
    <Form form={form} initialValues={initialValues} onFinish={handleFinish}>
      <MemberSelectField readOnly={isEdit} />
      <FormItem name="roleId" label="Job title" rules={FIELD_RULES}>
        <Select // readOnly={isEdit}
          options={roleEditOptions}
        />
      </FormItem>
      {/* {orgType === 'team' && <AssistantSelectField />} */}
      {orgType === 'broker' && <Field name="licenseNumber" label="License number" /> }
      <Field name="email" label="Email" type="email" /*readOnly={isEdit} */ />
      <Field name="phone" label="Phone number" />
      <Box mt={12}>
        <Button
          block
          htmlType="submit"
          loading={isAssignMutating || isAssignMutating}
        >
          {isEdit ? 'Save' : 'Save team member'}
        </Button>
      </Box>
    </Form>
  )
}
